import { IBusinessInfo } from "api/interfaces/account.type";
import { IHomePage } from "api/interfaces/home/home.type";
import axios from "fetch-api/fetch-api";
import { RootState, SSRProps } from "interfaces/generics.type";
import HomeClient from "modules/home/HomeClient";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import nextI18nextConfig from "../../next-i18next.config";
import HomeContainer from "../modules/home/HomeContainer";

function HomePage({ homeJson, isOldBuildId }: { homeJson: IHomePage, sitejaberData: IBusinessInfo }) {
  const { averageRating, totalReviewCount } = useSelector((store: RootState) => store.authenticationState);
  useEffect(() => {
    if (isOldBuildId) {
      window.location.reload();
    }
  }, [isOldBuildId]);

  if (isOldBuildId) {
    return null;
  }
  return (
    <>
      <HomeClient />
      <HomeContainer
        homeJson={homeJson}
        googleReviewSummary={{ overallRating: averageRating, totalReviews: totalReviewCount }}
        contentNumber={8}
        showFullWidthSection
      />
    </>
  );
}

export async function getServerSideProps({ locale, res }: SSRProps) {
  let isOldBuildId = false;
  let data;
  try {
    const homeJSON = await axios.json(`${process.env.NEXT_PUBLIC_CMS}/${locale === "en" ? "home" : "fr-home"}/home.json`);
    if (!homeJSON) {
      throw new Error("HOME_JSON_NOT_FOUND");
    }
    data = homeJSON.data;
    // If homeJSON is HTML instead of JSON, reload the page
    if (typeof data !== "object") {
      throw new Error("HOME_JSON_NOT_FOUND");
    }

    // const sitejabberAPI = await getSitejabberBusinessInfoApi();
  } catch (err) {
    if (err.message === "HOME_JSON_NOT_FOUND") {
      isOldBuildId = true;
    }
  }

  const localesToLoad = ["common", "category-map", "home"];
  const ssrTranslations = await serverSideTranslations(locale, localesToLoad, nextI18nextConfig);
  ssrTranslations._nextI18Next.initialI18nStore = {
    [locale]: ssrTranslations._nextI18Next.initialI18nStore[locale],
  };
  if (!res.headersSent) {
    res.setHeader("cache-control", "max-age=3600");
  }

  if (isOldBuildId) {
    return {
      props: {
        ...ssrTranslations,
        isOldBuildId,
      },
    };
  }

  return {
    props: {
      ...ssrTranslations,
      homeJson: data,
    },
  };
}

export default HomePage;
